import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { StringHelper } from '../helpers/strings.helper';
import { Pnd, PndRequest } from '../../shared/models/utility.model';
import { Subject } from 'rxjs';

@Injectable()
export class PndService {
	private pndModalRequest: PndRequest;
	private searchParams: any
	private requestAction;
	private isSearch: boolean;
	private _pndModalDestroy = new Subject<any>();
	_pndModalDestroy$ = this._pndModalDestroy.asObservable();

	constructor(
		private apiClientHelper: ApiClientHelper,
		public config: AppConfig,
	) {
	}

	setIsSearch(search: boolean) {
		this.isSearch = search;
	}

	getIsSearch() {
		return this.isSearch;
	}

	setPndModalRequest(pndModalRequest: PndRequest) {
		this.pndModalRequest = pndModalRequest;
	}

	setSearchParams(params) {
		this.searchParams = params;
	}

	getSearchParams() {
		return this.searchParams;
	}

	destroyModal(action) {
		this._pndModalDestroy.next(action);
	}

	getPndModalRequest() {
		return this.pndModalRequest;
	}

	placePndRequest(agentId, urlParams, params?): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v2/pnd-activation/agent/${agentId}/${urlParams}`;
		return this.apiClientHelper.postForPromise(url, params ?? agentId);
	}

	getPndRequest(params): Promise<Pnd> {
		params = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/super-aggregators/agents/pnd-requests?${params}`;
		return this.apiClientHelper.getForPromise(url);
	}

	treatPndRequest(params): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/super-aggregators/agents/treat-pnd-requests`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	setRequestAction(action) {
		this.requestAction = action;
	}

	getRequestAction() {
		return this.requestAction;
	}
}
